/**
 * Functional chat service for external component integration
 * - Provides waitForListenerReady for timing external messages
 */

// Module-level state
let listenerReady: boolean = false;
let readyPromiseResolve: ((value: void) => void) | null = null;
let readyPromise: Promise<void> | null = null;
/**
 * Mark the listener as ready (called when chat context initializes).
 */
export function setChatListenerReady(ready: boolean): void {
  listenerReady = ready;

  if (ready && readyPromiseResolve) {
    readyPromiseResolve();
    readyPromiseResolve = null;
    readyPromise = null;
  }

  if (!ready) {
    readyPromise = null;
    readyPromiseResolve = null;
  }
}

/**
 * Returns a promise that resolves when a listener is ready
 * Used by external components to ensure proper timing
 */
export function waitForChatListenerReady(): Promise<void> {
  if (listenerReady) {
    return Promise.resolve();
  }

  // Create the promise if it doesn't exist
  if (!readyPromise) {
    readyPromise = new Promise<void>((resolve) => {
      readyPromiseResolve = resolve;
    });
  }

  return readyPromise;
}

/**
 * Check if the listener is ready.
 */
export function isChatListenerReady(): boolean {
  return listenerReady;
}
